import React from "react";

const AnimationVolume = () => {
    return (
        <div id="volume_icon_portal"></div>
    );
};

export default AnimationVolume;